import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./OurUSPs.scss"; // Ensure global styles are imported
import useScrollReveal from "../useScrollReveal";

const OurUSPs = () => {
  useScrollReveal();

  const uspsData = [
    {
      category: "Safety",
      achievement:
        "Zero Major Accidents in the last four years with our relentless focus on Safety.",
      icon: "🛡️", // Shield Emoji for Safety
    },
    {
      category: "Quality",
      achievement:
        "Zero PPM achieved with our customers Tenneco, JBM, and Rambal for Quality.",
      icon: "⭐", // Star for Quality
    },
    {
      category: "Employee Retention",
      achievement:
        "50%+ employees retained for over 10 years, ensuring continuity and customer satisfaction.",
      icon: "👥", // People for Employee Retention
    },
    {
      category: "Flexibility",
      achievement:
        "Capability to handle volume variations, manufacturing from 500 to 160,000 units per month.",
      icon: "🔄", // Reload/Exchange for Flexibility
    },
    {
      category: "Variety",
      achievement:
        "Manufacturing 100+ part numbers for major automotive brands like Ford, FCA, Toyota, Maruti, Nissan, etc.",
      icon: "🚗", // Car for Automotive Variety
    },
    {
      category: "Agility",
      achievement:
        "Reduced lead time for Proto Stamped parts development from 30 days to 15 days.",
      icon: "⚡", // Lightning for Agility
    },
  ];
  
  return (
    <section className="usps">
      <div className="container">
        <h2 className="text-center usp-title">Our USP's</h2>
        <div className="row justify-content-center">
          {uspsData.map((item, index) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-3 mb-6 d-flex align-items-stretch"
              key={index}
            >
              <div className="usp-card">
              <div className="usp-icon">{item.icon}
                </div>
                <h4 className="usp-category">{item.category}</h4>
                <p className="usp-achievement">{item.achievement}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurUSPs;
